// Pop Messages
export const POP = {
  BILL_CREATED: 'Bill Created in Draft Mode',
  ALL_BOXES_SCANNED: 'All boxes scanned in this shipment',
  SKU_ADDED: 'SKU added successfully',
  FILL_ALL_SKU_DETAIL: 'Please fill all details of SKU',
};

//Button texts
export const BUTTON = {
  CREATE_BILL: 'Create Bill',
  SUBMIT_DISPATCH: 'Validate',
  UPDATE_DISPATCH_DETAIL: 'Update Dispatch Details',
  SAVE_CONTAINER_NO: 'Save Invoice No',
  CREATE_PACKAGE_AND_VALIDATE: 'Create Package and Validate',
  SUBMIT: 'Validate',
  TRUE_SUBMIT: 'Submit',
  SAVE_AS_DRAFT: 'Save As Draft',
  BACK: 'Back',
  SCAN_BOX: 'Scan Box',
  PRINT_PACKING_LIST: 'Print Packing List',
  PRINT_BILL: 'Print Bill',
  CREATE_DISPATCH: 'Create Dispatch',
  SIGN_IN: 'Sign In',
  CREATE_BATCH: 'Create Cutting Report',
  CREATE_SEW_REPORT: 'Create Sew Report',
  CLOSE: 'Close',
  SCAN_BLP: 'Scan BLP',
  SUBMIT_SKU: 'Validate',
  ADD_ROW: 'Add Row',
  PRINT_LABEL: 'Print Label',
  ADD_BOX: 'Add Box',
  ADD_BILL: 'Add Bill',
  GENERATE_BLP: 'Generate BLP Labels',
  GENERATE_3PACK_BLP: 'Generate 3-Pack BLP Labels',
  REPRINT_3PACK_BLP: 'Reprint 3-Pack BLP Labels',
  GENERATE_BILL: 'Generate Bill',
  CANCEL: 'Cancel',
  VALIDATE: 'Validate',
  UPDATE: 'Update',
  UPDATE_DETAILS: 'Update Details',
  CONFIRM: 'Confirm',
  READY_FOR_PACK: 'Ready for Packing',
  READY_FOR_DYEING: 'Ready for Dyeing',
  SAVE: 'Save',
  SEARCH: 'Search',
  CANCEL_DISPATCH: 'Cancel Dispatch',
  CLEAR_FILTERS: 'Clear Filters',
  STOP_SCAN: 'Stop Scan',
  DISPATCH: 'Validate',
  DELETE_BATCH: 'Delete Cut Report',
  DELETE_SEW_BATCH: 'Delete Sewing Report',
  APPLY: 'Apply',
  REMOVE: 'Remove',
  GROUP_DISPATCH: 'Group Dispatch',
  GROUP_RECEIPTS: 'Group Receipts',
  BULK_MANUFACTURING: 'Manual Update',
  IMPORT: 'Import',
  IMPORT_CSV: 'Import CSV',
  EXPORT: 'Export',
  EXPORT_CSV: 'Export CSV',
  EXPORT_TEMPLATE: 'Export Template',
  SELECT_ALL: 'Select All',
  PRINT: 'Print'
};

// Other texts
export const TEXT = {
  NO_BATCH_AVAILABLE: 'No Cutting Reports Available, To add New cutting reports click Below Button',
  MATERIAL_NOT_AVAILABLE: 'Material not available to create cutting report',
  BATCH_NO: 'Cutting Report No',
  ORDER_QTY: 'Order Qty',
  CUT_QTY: 'Cut Quantity',
  CUT_DATE: 'Cut Date',
  SEW_QTY: 'Sew Quantity',
  SEW_DATE: 'Sew Date',
  DYE_QTY: 'Dye Quantity',
  DYE_DATE: 'Dye Date',
  PACKAGE_QTY: 'Packaged Quantity',
  PACKAGE_DATE: 'Packaged Date',
  ORDER_STATUS: 'Order Status',
  READY: 'Ready For Packaging',
  NO_ACCOUNT: 'Don’t have an account?',
  NO_LOGOUT: 'Unable to Logout at this moment',
  BOX_SIZE: 'Box Size',
  BOX_TYPE: 'Box Type',
  SEWN_SHIRTS: 'Sewn Shirts',
  MAX_3PACKS: 'Max 3-Packs Possible',
  NUM_3PACKS: 'Number of 3-Packs',
  FULL_BOXES: 'BLPs for full 3-Pack Boxes',
  FULL_SHIRT_BOXES: 'BLPs for full Individual Shirt Boxes',
  LEFTOVER_3PACKS: 'Leftover 3-Packs (Mix Pool)',
  LEFTOVER_SHIRTS: 'Leftover Individual Shirts (Mix Pool)',
};

// Heading texts
export const HEADING = {
  BATCH_CREATION: 'Cutting Report Creation',
  EDIT_CUT_BATCH: 'Edit Cutting Report',
  EDIT_SEW_BATCH: 'Edit Sewing Report',
  BOX_COUNT: 'Box Count',
  SCAN_BARCODE: 'Scan a Barcode/QR',
  SELECT_SCAN_MODE: 'Please select scan mode',
  SETTINGS: 'Settings',
};

// Routes
export const ROUTES = {
  HOME: '/',
  EMPTY: '',
  LOGIN: '/login',
  SERVER_ERROR: '/server_error',
  DASHBOARD: '/dashboard',
  PURCHASE_ORDER: '/purchase_order',
  PO_DETAILS: '/purchase_order_detail',
  BILLS: '/bills',
  BILL_DETAILS: '/bill_detail',
  CREATE_BILL: '/create_bill',
  RECEIPT: '/receipt',
  RECEIPT_DETAILS: '/receipt_detail',
  PRODUCTION: 'production',
  MANUFACTURING: '/manufacturing',
  LOGS: '/logs',
  LOG_DETAILS: '/log_details',
  LOT_DETAILS: '/lot_details',
  BLP_OVERVIEW: '/blp_overview',
  PACKAGE: '/package',
  PACKAGE_BLP_OVERVIEW: '/package_blp',
  ADD_MIX_BOX: '/add_mix_box',
  MIX_BOX_SUMMARY: '/mix_box_summary',
  PACKAGE_DETAILS: '/package_detail',
  DISPATCH: '/dispatch',
  DISPATCH_BLP_OVERVIEW: '/dispatch_blp',
  CREATE_DISPATCH: '/create_dispatch',
  DISPATCH_DETAILS: '/dispatch_detail',
  FABRIC_DISPATCH_DETAIL: '/fabric_dispatch_detail',
  YARN_DISPATCH_DETAIL: '/yarn_dispatch_detail',
  REPORTS: '/reports',
  URL: '/:url',
  NULL: '/',
  CONTAINER_THREAD_BOX_ENTRY: '/container_box_thread',
};

// methods
export const METHODS = {
  UPDATE: 'UPDATE',
  POST: 'POST',
  GET: 'GET',
  DELETE: 'DELETE',
  PUT: 'PUT',
  PATCH: 'PATCH',
};

// headers
export const HEADERS = {
  APPLICATION_JSON: 'application/json',
  AUTHORIZATION: 'Bearer',
};

// API Endpoints
export const API = {
  VENDOR_LOGIN: '/login',
  VENDOR_LOGOUT: '/logout',
  RECEIPT: '/receipt',
  PURCHASE: '/purchase',
  BILLS: '/bill',
  DISPATCH: '/dispatch',
  SHIPMENT: '/shipment',
  MANUFACTURING: '/manufacture/receipt',
  SAVE_AS_DRAFT: '/manufacturing/save_as_draft',
  BULK_VALIDATE: '/bulk/production/validate',
  UPDATE_PRIORITY: '/manufacture/update/priority',
  CREATE_DISPATCH: '/dispatch/create',
  DELETE_DISPATCH: '/dispatch/cancel',
  SUBMIT_DISPATCH: '/dispatch/marked',
  MODAL_DISPATCH: '/dispatch/move_details',
  MODAL_SUBMIT_DISPATCH: '/dispatch/mark_production',
  PACKAGE: '/packages',
  CREATE_BILL: '/purchase/bill/create',
  UPDATE_BILL: '/bill/update',
  LOT_DETAILS: '/manufacture/get_batch_lot',
  BATCH_CREATION: '/manufacture/batch/create',
  QTY_UPDATE: '/manufacture/update/quantity',
  BATCH_UPSERT: '/manufacture/batch/upsert', // New: Single endpoint for create + update
  DELETE_BATCH: '/manufacture/batch/delete',
  READY_TO_PACK: '/manufacture/ready_for_packaging',
  READY_TO_DYE: '/manufacture/complete/batch',
  PRODUCT_IMAGE: '/manufacture/product/image',
  DISPATCH_VALIDATE: '/dispatch/validate',
  RECEIPT_UPDATE: '/receipt/move/update',
  RECEIPT_MOVE_IDS: '/receipt/move_ids',
  MIX_BOX_PACKAGE: '/get/mix_packages_details',
  SUBMIT_SKU_MIX_BOX_PACKAGE: '/create/package',
  PRINT_LABEL_PACKAGE: '/print/label',
  BATCH_LIST: '/manufacture/lot_details',
  PRINT_LABEL: '/print/label',
  READY_FOR_DISPATCH: '/dispatch/mark_ready_for_dispatch',
  BLP_LIST: '/manufacturing/get_packages_for_batch',
  CONVERT_TO_3PACK: '/manufacture/convert_to_3pack',
  DISPATCH_STATUS: '/dispatch/status_change',
  READY_FOR_PACKAGE_PICKING: '/dispatch/move_packaging',
  UPDATE_DISPATCH_DETAILS: '/dispatch/update',
  REPORT: '/wip/report',
  EXPORT_WIP_REPORT: '/wip/export',
  GROUP_BY: '/groupby',
  DISPATCH_PRINT_PACKING_LIST: '/dispatch/packing_list',
  DISPATCH_BILL_CREATION: '/dispatch/bill/create',
  UPDATE_BILL_LINE: '/dispatch/bill/vendorcost/update',
  DELETE_BILL_LINE: '/billline/delete',
  EXPORT_MANUFACTURING: '/export/manufacturing',
  EXPORT_MANUFACTURING_TEMPLATE: '/export/manufacturing/template',
  IMPORT_MANUFACTURING: '/import/manufacturing',
  PRINT_PACKING_LIST: '/dispatch/packing_list',
  BILL_PACKING_LIST: '/bill/packing_list',
  LAST_MESSAGE_ID: '/bus/last_message_id',
  MANUFACTURING_LOGS: '/manufacturing/log',
  MANUFACTURING_LOG_LINES: '/manufacturing/log_line',
};

// Status Codes
export const HTTP_CODES = { INVALID_TOKEN: 498, INTERNAL_SERVER_ERROR: 500, OK: 200 };

// Tiles
export const TILES = {
  PURCHASE_ORDER: 'Orders',
  BILLS: 'Bills',
  RECEIPT: 'Receipts',
  MANUFACTURING: 'Manufacturing',
  PACKAGE: 'Packages',
  DISPATCH: 'Dispatch',
  REPORTS: 'WIP Reports',
  LOGS: 'Process Logs'
};

// Titles
export const TITLES = {
  DASHBOARD: 'Dashboard',
  RECEIPT: 'Receipts',
  RECEIPT_INNER: 'Receipt',
  BILLS: 'Bills',
  BILL_DETAILS: 'Bill',
  REPORTS: 'WIP Reports',
  PURCHASE_ORDER: 'Orders',
  PURCHASE_ORDER_INNER: 'Order (P00060)',
  PACKAGE: 'Packages',
  MANUFACTURING: 'Manufacturing',
  DISPATCH: 'Dispatch',
  CREATE_DISPATCH: 'Create Dispatch',
  BLP_OVERVIEW: 'BLP',
  ADD_BOX: 'Add Box',
  CREATE_BILL: 'Create Bill',
  LOGS: 'Process Logs'
};

// Manufacturing Status
export const MFG_STATUS = [
  {
    name: 'Completed',
    className: 'light-green',
  },
  {
    name: 'Partially Done',
    className: 'yellow',
  },
  {
    name: 'Pending',
    className: 'bright-orange',
  },
];

// Local Storage
export const LOCAL_STORAGE = {
  AUTH_TOKEN: 'auth_token',
  ALLOWED_APP: 'allowed_apps',
  TAGS: 'tags',
  USERNAME: 'username',
  VENDOR_TYPE: 'vendor_type',
  USER_EMAIL: 'user_email',
};

// Packaging Status
export const PKJ_STATUS = [
  {
    name: 'Single Box',
    className: 'blue-shade',
  },
  {
    name: 'Mix Box',
    className: 'pink-shade',
  },
];

export const DROPDOWN = {
  PO_SORT_1: ['To Invoice', 'Invoiced', 'No'],
  PO_SORT_2: ['Pending', 'Partial', 'Full'],
  BILL_SORT: ['Draft'],
  MFG_SORT_1: ['Priority', 'Make First Order', 'Low Priority'],
  MFG_SORT_2: [' Pending', 'Completed', 'Partially Done'],
  PKJ_SORT_1: ['Single Box', 'Mix Box'],
  PKJ_SORT_2: ['BLP', 'SKU'],
  BOX_OPTION: ['12_4'],
  REPORT_TYPE: ['Cutting Report', 'Sewing Report'],
};

export const VALIDATION = {
  CREDENTIAL_MISMATCH: 'Email ID or Password does not Match',
};

export const ERROR = {
  INVALID_LOCAL_STORAGE_KEY_OR_VALUE: 'Invalid Key value Pair',
};

export const DISPLAY_TEXTS = {
  FABRIC_DISPATCH: [
    'Record Production Quantity',
    'Lot No:',
    'Demand Quantity:',
    'Producing Quantity:',
    'Produced Quantity:',
  ],
  BLP_TILES: ['BLP-', 'SKU-', 'Batch-'],
  CREATE_DISPATCH: ['Shipment No -', 'Box Count'],
  FABRIC_DISPATCH_MODAL: ['Product', 'Lot No', 'Available Quantity', 'Quantity'],
};

export const POPUP_MSG = {
  MISSING_INVOICE:
    'Some invoice numbers are missing or dispatches are empty, add them before proceeding',
  INVALID_DATE: 'Please Select Correct Date from Calender',
  ENTER_QTY: ' Enter Quantity ',
  SELECT_LOT: 'Please select Lot to create cutting report',
  SURE: 'Are You Sure ?',
  QTY_WILL_SAVE: 'Quantity will be Saved Permanently',
  SUBMIT_DISPATCH_WARNING:
    'Once the dispatch has been submitted, scanning and adding additional packages to that dispatch will no longer be permitted',
  INVALID_QTY: ({ status, compare }) =>
    `${status.charAt(0).toUpperCase() + status.slice(1)} quantity should be equal or less than ${compare.charAt(0).toUpperCase() + compare.slice(1)} quantity`,
  INVALID_QTY_MSG: 'Invalid Action, Enter Quantity more than equal to 0',
  NOT_DISPATCHED: 'Product not Dispatched from',
  MAX_QTY: 'Max allowed Quantity',
  IMAGE_NOT_FOUND: 'Product Image Not Found',
  TOKEN_EXPIRED: 'Token Expired',
  SELECT_PACKAGE: 'Select packages to print label',
  PRINT_LIMIT: 'Please do not print more than 100 label at once',
  GROUP_SUBMISSION:
    'Once the dispatches have been submitted, scanning and adding additional packages to these dispatches will no longer be permitted',
  QTY_EXCEED: 'Quantity exceeds available',
};
export const POPUP_TYPE = {
  ERR: 'error',
  SUCCESS: 'success',
};
export const DATA_FIELD = {
  RECEIVED: 'received',
  BILLED: 'billed',
  QTY: 'quantity',
  PRICE_SUM: 'price_subtotal',
  PACKED: 'packed',
  ORDER_QTY: 'order_qty',
};
export const APPS = {
  DASHBOARD: 'dashboard',
  PURCHASE: 'purchase',
  BILL: 'bill',
  RECEIPT: 'receipt',
  MFG: 'manufacture',
  LOGS: 'manufacturing_log',
  PROD: 'production',
  PACK: 'packages',
  DISPATCH: 'dispatch',
  REPORT: 'report',
  REPORT_NAME: 'wip_report',
};
export const STATUS = {
  FAIL: 'fail',
  PASS: 'pass',
  READY: 'ready',
  CUT: 'cut',
  SEW: 'sew',
  DYE: 'dye',
  PACK: 'pack',
  ORDER: 'order',
};

/**
 * Edit box states for batch management UI
 * Used to control which view is displayed in BatchEditBox
 */
export const EDIT_BOX_STATE = {
  CLOSED: 0,
  CREATE: 1,
  EDIT: 2,
  BLP: 3,
};

export const DB = 'shakawear_staging';

export const FORM_FIELD = {
  EMAIL: 'Email',
  PASSWORD: 'Password',
  SIGN_UP: 'Sign up',
  LOG_OUT: ' Log Out',
};
export const PLACEHOLDER = {
  ENTER_BATCH_QTY: 'Enter Cutting Quantity',
  ENTER_DATE: 'Enter Date',
  ENTER_DISPATCH_QTY: 'Enter Dispatched Quantity',
  REMAINING_QTY: 'Remaining Quantity',
};
export const SORTING = {
  DEFAULT: 'Default',
  ASCENDING: 'Asc',
  DESCENDING: 'Dsc',
};

export const VENDOR = {
  FABRIC: 'fabric',
  CLOTH: 'clothing',
  YARN: 'yarn',
  DYE: 'dyeing',
  LABEL: 'labels',
  FINISHED_GOODS: 'finished_goods',
};

export const SCANOPTIONS = {
  SCAN_GUN: 'Scan Gun',
  CAMERA: 'Camera',
};

export const GROUP_BY = {
  TITLE: 'GROUP_BY',
  RECEIPT: 'receipt',
  DISPATCH: 'dispatch',
  ORDER: 'order',
  MANUFACTURING: 'manufacturing',
  LOG_LINE: 'log_line'
};
